"use client";

import dynamic from "next/dynamic";
import type { HeroSubtitleMediaClientDemoProps } from "./HeroSubtitleMediaClientDemo";

const HeroSubtitleMediaClientDemo = dynamic(() => import("./HeroSubtitleMediaClientDemo").then(mod => mod.default));

export default function HeroSubtitleMediaLazy(props: HeroSubtitleMediaClientDemoProps) {
  return <HeroSubtitleMediaClientDemo {...props} />;
}
